import { useState, useEffect, useRef } from "react";


import ContactForm from "./ContactForm";
import Reseau from "./Reseau";


export default function Contact() {
  const [trail, setTrail] = useState([]);
  
  // State pour gérer la taille de l'écran de façon responsive
  const [screenSize, setScreenSize] = useState({ 
    width: typeof window !== 'undefined' ? window.innerWidth : 1024, 
    height: typeof window !== 'undefined' ? window.innerHeight : 768 
  });
  
  // Vérifier si on est sur mobile
  const isMobile = screenSize.width < 768;
  
  // Références pour la position cible et la position actuelle interpolée
  const targetMouse = useRef({ x: screenSize.width / 2, y: screenSize.height / 2 });
  const currentMouse = useRef({ x: screenSize.width / 2, y: screenSize.height / 2 });
  
  // Ref du conteneur et état pour son offset
  const containerRef = useRef(null);
  const [offset, setOffset] = useState({ top: 0, left: 0 });
  
  // Au montage, on calcule l'offset du conteneur
  useEffect(() => {
    const updateOffset = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setOffset({ top: rect.top + window.scrollY, left: rect.left + window.scrollX });
      }
    };

    updateOffset();
    
    // Gestion du redimensionnement d'écran
    const handleResize = () => {
      const newSize = { width: window.innerWidth, height: window.innerHeight };
      setScreenSize(newSize);
      targetMouse.current = { x: newSize.width / 2, y: newSize.height / 2 };
      currentMouse.current = { x: newSize.width / 2, y: newSize.height / 2 };
      updateOffset();
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', updateOffset);
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('scroll', updateOffset);
    };
  }, []);
  
  // Fonction de lerp pour interpoler de manière fluide
  const lerp = (start, end, amt) => (1 - amt) * start + amt * end;
  
  // Màj de la position cible au déplacement de la souris (désactivé sur mobile)
  useEffect(() => {
    if (isMobile) return;
    
    const handleMouseMove = (e) => {
      targetMouse.current = { x: e.pageX, y: e.pageY };
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, [isMobile]);
  
  // Boucle d'animation pour interpoler currentMouse vers targetMouse et mettre à jour le ruban (désactivé sur mobile)
  useEffect(() => {
    if (isMobile) {
      setTrail([]);
      return;
    }
    
    let animationFrameId;
    const animate = () => {
      currentMouse.current = {
        x: lerp(currentMouse.current.x, targetMouse.current.x, 0.1),
        y: lerp(currentMouse.current.y, targetMouse.current.y, 0.1)
      };
      setTrail(prev => {
        const newTrail = [...prev, { ...currentMouse.current }];
        if (newTrail.length > 20) newTrail.shift();
        return newTrail;
      });
      animationFrameId = requestAnimationFrame(animate);
    };
    animate();
    return () => cancelAnimationFrame(animationFrameId);
  }, [isMobile]);
  
  return (
    <div id="Contact" ref={containerRef} className="relative min-h-screen w-full bg-white pt-10 pb-40">
      {/* SVG en arrière-plan pour dessiner le ruban (masqué sur mobile) */}
      {!isMobile && (
        <svg
          className="absolute top-0 left-0 w-full h-full pointer-events-none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {trail.map((point, index) => {
            if (index === 0) return null;
            const prev = trail[index - 1];
            // L'opacité varie de faible pour les points anciens à forte pour les plus récents
            const opacity = (index + 1) / trail.length;
            return (
              <line
                key={index}
                x1={prev.x - offset.left}
                y1={prev.y - offset.top}
                x2={point.x - offset.left}
                y2={point.y - offset.top}
                stroke={`rgba(0,0,0,${opacity})`}
                strokeWidth="6"
                strokeLinecap="round"
              />
            );
          })}
        </svg>
      )}

      {/* Vos éléments existants */}
      <div className="min-h-screen w-full">
        <div className="w-full px-4 sm:px-6 md:px-8 lg:px-12 xl:px-18 py-6 sm:py-8 md:py-10 lg:py-12 flex flex-col justify-center items-center">
          <h1 className="px-4 sm:px-6 md:px-8 lg:px-12 xl:mx-40 text-black text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-center font-semibold mb-6 sm:mb-8">
            Pour me contacter ...
          </h1>
          
          <div className="my-4 sm:my-6 text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-center text-gray-500">
            ici
          </div>
          
          <div className="w-full mb-8 sm:mb-12">
            <ContactForm/>
          </div>
  
          <div className="my-4 sm:my-6 text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-center text-gray-500">
            ou ici
          </div>
          
          <div className="mb-8 sm:mb-12">
            <Reseau/>
          </div>

          <h2 className="mx-4 sm:mx-6 md:mx-8 lg:mx-10 text-lg sm:text-xl md:text-2xl lg:text-3xl font-light text-center text-gray-500 leading-relaxed">
            Je vous remercie pour votre confiance
          </h2>
        </div>
      </div>
    </div>
  );
}
